<!--
 * @Description: 不通过
 * @Date: 2021-06-28 18:44:27
-->
<template>
  <el-dialog
    title="审核不通过"
    width="800px"
    :close-on-click-modal="false"
    :visible="true"
    :before-close="close"
  >
    <div class="reject">
      <div class="reject__content">
        <div class="text-area">
          <el-input
            style="width:400px"
            type="textarea"
            :autosize="{
              minRows: 9
            }"
            :maxlength="200"
            :show-word-limit="true"
            placeholder="请输入批注(您可以点击下方内容进行快捷回复)"
            v-model.trim="textarea"
          ></el-input>
        </div>
        <div class="select-area" style="overflow-y: scroll">
          <ol>
            <li>
              <h2>请选择快捷批注内容</h2>
            </li>
            <li
              class="select-text"
              v-for="(item, index) in textArray"
              :key="index"
              @click="textarea += item.content"
            >
              <span>{{ index + 1 }}.{{ item.content }}</span>
              <el-button
                v-if="item.id"
                size="mini"
                type="text"
                plain
                @click.stop="send('remove', { id: item.id })"
                style="color:red;width: 50px"
              >
                ✖
              </el-button>
            </li>
          </ol>
        </div>
      </div>

      <div class="footer">
        <el-button @click="confirm(1)" type="primary" plain>
          提交并加入快捷回复
        </el-button>
        <el-button @click="confirm(0)" type="primary" plain>仅提交</el-button>
        <!--      <el-button @click="send('zuofei')" type="primary" plain>作废</el-button>-->
        <el-button @click="close" type="primary" plain>关闭</el-button>
        <!--      <el-button type="primary" @click="confirm">确 定</el-button>-->
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { fastReply } from '../api';

export default {
  data() {
    return {
      dialogVisibleReject: false,
      textarea: '',
      textDefault: [
        { content: '图片不清晰' },
        { content: '定位地点错误' },
        { content: '不符合任务要求' }
      ],
      textArray: []
    };
  },
  methods: {
    async send(type, param) {
      if (type === 'remove') {
        await this.$confirm('是否删除快捷回复');
        await fastReply.delete(param);
        await this.queryData();
      }
    },
    // type 1提交并保存信息 0仅提交
    confirm(type) {
      this.$emit('confirm', { textarea: this.textarea, type });
    },
    async close() {
      this.$emit('close');
    },
    async queryData() {
      const {
        projectId,
        csoEnterpriseId: enterpriseId // TODO: 后端未完成，待修改
      } = this.$store.state.dataAnalysis.projectDetail;

      const { data } = await fastReply.get({
        projectId,
        enterpriseId
      });
      this.textArray = [...this.textDefault, ...data['data']];
    }
  },
  async created() {
    await this.queryData();
  }
};
</script>
<style lang="scss" scoped>
.reject {
  width: 700px;
  &__content {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}
.select-area {
  text-align: left;
  .select-text {
    margin-top: 23px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    display: flex;
    justify-content: space-between;
  }
  .select-text:hover {
    background-color: #fff;
    cursor: pointer;
  }
  width: 280px;
  padding: 20px;
  height: 199px;
  background: #f5f7fa;
  border-radius: 2px;
  opacity: 0.99;
}
.footer {
  text-align: right;
  margin-top: 30px;
}
</style>
